import { Currency } from '@/core/currency/interfaces';

const VES: Currency = {
    name: 'Venezuelan Bolívar Soberano',
    demonym: 'Venezuelan',
    majorSingle: 'Bolívar',
    majorPlural: 'Bolívares',
    codeNumeric: '928',
    symbol: 'Bs.F',
    symbolNative: 'Bs.F',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'VES',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default VES;
